import React from 'react';

const SuccessStories = () => {
return (
	<>
  <section
    className="success-stories bg-250147"
    style={{ backgroundImage: "url(assets/img/success-bg.png)" }}
  >
    <i className="glow-3" />
    <div className="container-lg inner-container position-relative text-white text-center">
      <h1>Success Stories</h1>
      <div className="row justify-content-center">
        <div className="col-lg-10 px-lg-5">
          <p>
            We listen to our clients' challenges and objectives and build a
            comprehensive plan to help them achieve their business goals.
            Drawing upon our deep expertise in various aspects of marketing and
            our capabilities in branding, content and technology, we tailor an
            execution strategy uniquely designed to accelerate your business.
            Here are some examples of how Purplepatch transformed B2B tech
            brands.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section className="success-stories-list">
    <div className="container-lg inner-container position-relative">
      <div className="row suc-rw">
        {/* loop*/}
        <div className="col-lg-4 col-sm-6">
          <div className="case-boxx d-flex text-center">
            <div className="coo">
              <a
                href="https://www.accellor.com/"
                className="site-links"
                target="_blank"
                title="https://www.accellor.com"
              />
              <div className="iim-sec">
                <img src="assets/img/clients-1/accellor-3.svg" alt="Accellor" />
              </div>
              <a href="accellor.html" className="r-case">
                Read Story
              </a>
            </div>
          </div>
        </div>
        {/* loop End*/}
        <div className="col-lg-4 col-sm-6">
          <div className="case-boxx d-flex text-center">
            <div className="coo">
              <a href="#" className="site-links" target="_blank" title="#" />
              <div className="iim-sec">
                <img
                  src="assets/img/clients-1/alignedautomation.svg"
                  alt="Accellor"
                />
              </div>
              <a href="#" className="r-case">
                Read Story
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-sm-6">
          <div className="case-boxx d-flex text-center">
            <div className="coo">
              <a href="#" className="site-links" target="_blank" title="#" />
              <div className="iim-sec">
                <img src="assets/img/clients-1/allyo.svg" alt="Accellor" />
              </div>
              <a href="#" className="r-case">
                Read Story
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-4 col-sm-6">
          <div className="case-boxx d-flex text-center">
            <div className="coo">
              <a href="#" className="site-links" target="_blank" title="#" />
              <div className="iim-sec">
                <img src="assets/img/clients-1/asparia.svg" alt="Accellor" />
              </div>
              <a
                href="#"
                className="r-case"
                data-bs-toggle="modal"
                data-bs-target="#m1"
              >
                Read Story
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div
    className="modal fade success-modal"
    id="m1"
    tabIndex={-1}
    aria-labelledby="modal"
    aria-hidden="true"
  >
    <div className="modal-dialog modal-dialog-scrollable">
      <div className="bg-232323 success-main-content">
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        />
        <div className="container-lg inner-container">
          <div
            className="bg-white position-relative success-main-content-in"
            style={{ backgroundImage: "url(assets/img/accellor-logo-bg.svg)" }}
          >
            <div className="row justify-content-center">
              <div className="col-md-10">
                <div className="">
                  <img
                    src="assets/img/clients-1/accellor-3.svg"
                    className="pb-4 pb-md-5"
                    alt="accellor"
                  />
                  <div className="line-left pb-md-5 pm-3">
                    <p>
                      Popcorn Apps was a Salesforce consulting company based out
                      of Fremont, CA. While the core business was in Salesforce
                      implementation and support, the founders—strong in
                      technical and functional roles—were often tasked to help
                      in business strategy and technology program management.
                      Clearly, the company was not leveraging the larger
                      capability of transformation consulting.
                    </p>
                    <p>
                      Purplepatch worked with the client to understand how they
                      approached the transformation, and created the unique
                      Digital Continuum framework—initiate every project with a
                      Digital Transition program, then accelerate to Digital
                      Transformation, and eventually continue the momentum by
                      supporting the Digital Continuum.
                    </p>
                    <p>
                      We also rebranded the company as Accellor—accelerating
                      digital continuum. Today, Accellor is strongly positioned
                      to drive transformational work for both high growth and
                      large enterprises.
                    </p>
                  </div>
                </div>
                <div className="acce-port">
                  <div className="row justify-content-center gy-3">
                    <div className="col-lg-6">
                      <div className="innr-i">
                        <img
                          src="assets/img/accellor-home.png"
                          alt="accellor"
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="row gy-3">
                        <div className="col-12">
                          <div className="innr-i">
                            <img
                              src="assets/img/accellor-practices.png"
                              alt="accellor"
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="innr-i">
                            <img
                              src="assets/img/accellor-microsoft.png"
                              alt="accellor"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <section
    className="get-form-touch"
    style={{ backgroundImage: "url(assets/img/get-form-touch.png)" }}
  >
    <div className="container-lg inner-container">
      <div className="row">
        <div className="col-md-6 text-white">
          <h5 className="ss-1">Contact</h5>
          <h4 className="ss-2">
            Ready to start your growth with Our B2B Digital Marketing Service?
          </h4>
          <div className="home-feat-article">
            <div className="dflex-1 text-black">
              <div className="dflex-1-cnt">
                <h6>Featured Article</h6>
                <h5>What is good conversion rate?</h5>
              </div>
              <div className="dflex-1-icon">
                <img src="assets/img/peop-1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 text-white">
          <h6 className="ss-3">
            Your success story begins here. Connect with us today!
          </h6>
          <p>
            Are you ready to start elevating your brand and getting results?
            Then stop reading and start typing! Fill out the form and let’s
            begin…
          </p>
        </div>
      </div>
    </div>
  </section>
</>

  );
};

export default SuccessStories;